import React from 'react';
import profileImage from '../../../assets/images/singUpBanner.png';
import Calender from '../../../assets/images/Appointments/Date.svg';
import Time from '../../../assets/images/Appointments/Time.svg';
import moment from 'moment';
import { convertTo12HourFormat } from '../../../helpers/constants';

const AppointmentCard = ({
    appointments,
    title,
    length,
    handleCardClick,
    activeIndex,
}) => {
    return (
        <div className="appointment-container pe-2">
            <div className="heading-container mb-4">
                <div className={`heading f-30 ${!length && 'mb-2'}`} style={{ fontFamily: 'Poly', color: 'var(--c-2b5c35)' }}>
                    {title}
                </div>
                {length && (
                    <p className="description mb-0 text-muted f-14">
                        You have {length} upcoming{' '}
                        {length === 1 ? 'appointment' : 'appointments'}
                    </p>
                )}
            </div>
            <div className="appointment-card-list">
                {appointments?.map((appointment, index) => {
                    const businessName = 
                        appointment?.appointmentService?.[0]?.service?.business?.name || 
                        appointment?.business?.name || 
                        'BB Salons';
                    const businessPhoto = 
                        appointment?.appointmentService?.[0]?.service?.business?.pictures?.[0]?.photo_path || 
                        profileImage;

                    return (
                        <div
                            key={index}
                            className={`appointment-card ${
                                index === activeIndex ? 'active' : ''
                            }`}
                            onClick={() => handleCardClick(index, appointment)}
                        >
                            <div className="w-full">
                                <div className="d-flex align-items-start gap-3 p-3">
                                    <img
                                        src={businessPhoto}
                                        alt="Salon"
                                        className="profile-img"
                                        style={{ width: '80px', height: '80px', borderRadius: '12px', objectFit: 'cover' }}
                                    />
                                    <div className="d-flex flex-column flex-grow-1">
                                        <span className="heading fw-semibold f-16 mb-1 text-dark" style={{ fontFamily: 'Poppins' }}>
                                            {businessName}
                                        </span>
                                        <div className="d-flex gap-1 flex-wrap mb-2">
                                            {appointment?.appointmentService && appointment.appointmentService.length > 0 ? (
                                                appointment.appointmentService.map((item, idx) => (
                                                    <span key={idx} className="appointment-service-badge">
                                                        {item?.service?.name || 'Salon Service'}
                                                    </span>
                                                ))
                                            ) : (
                                                <span className="appointment-service-badge">
                                                    Salon Service
                                                </span>
                                            )}
                                        </div>
                                        <div className="d-flex align-items-center gap-2 mb-1 text-muted f-13">
                                            <img
                                                src={Calender}
                                                alt="Calendar"
                                                style={{ width: '14px', height: '14px' }}
                                            />
                                            <span>
                                                {appointment?.date &&
                                                    moment(appointment?.date).format('DD/MM/YYYY')}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                                            <div className="d-flex align-items-center gap-2 text-muted f-13">
                                                <img 
                                                    src={Time} 
                                                    alt="Time" 
                                                    style={{ width: '14px', height: '14px' }}
                                                />
                                                <span>
                                                    {convertTo12HourFormat(appointment?.time)}
                                                </span>
                                            </div>
                                            <div className="price fw-bold f-16 text-dark">
                                                £{appointment?.amount}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AppointmentCard;

